import { ChangeDetectorRef, Component, Inject, makeStateKey, OnInit, PLATFORM_ID, TransferState } from '@angular/core';
import { EventspageService } from '../eventspage.service';
import { ActivatedRoute } from '@angular/router';
import { CanonicalService } from 'src/app/shared/services/canonical.service';
import { EventArticleContentComponent } from './event-article-content/event-article-content.component';
import { EventArticleReEventsComponent } from './event-article-re-events/event-article-re-events.component';
import { EventsArticleApplyComponent } from './events-article-apply/events-article-apply.component';
import { CommonGetstartedComponent } from 'src/app/shared/components/getstarted/getstarted.component';
import { isPlatformServer } from '@angular/common';
import { PosthogService } from 'src/app/shared/services/posthog.service';

const CONTENTFUL_ENTRIES_KEY = makeStateKey<any[]>('contentfulEntries');

@Component({
  selector: 'app-events-article',
  templateUrl: './events-article.component.html',
  styleUrls: ['./events-article.component.scss'],
  imports: [
    EventArticleContentComponent,
    EventArticleReEventsComponent,
    EventsArticleApplyComponent,
    CommonGetstartedComponent,
  ],
})
export class EventsArticleComponent implements OnInit {
  getStartedData:any;
  pageData: any;
  keyName: any = '';
  constructor(
    private activeRoute: ActivatedRoute,
    private eventspageService: EventspageService,
    private transferState: TransferState,
    private route: ActivatedRoute,
    private canonical: CanonicalService,
    @Inject(PLATFORM_ID) private platformId: string,
    private cdr: ChangeDetectorRef,
    private posthogService: PosthogService
  ) {
    
  }

  async ngOnInit(): Promise<void> {
    // this.activeRoute.params.subscribe((param)=>{
    //   this.eventspageService.getEventsDetailData(param.eventdetail);
    // });
    this.canonical.setCanonicalURL();
    const fetchedData = await this.eventspageService.getAllEventsDetail();
    this.keyName = this.activeRoute.snapshot.params['eventdetail'];
    this.pageData = fetchedData.filter(
      (el:any) => el?.fields?.webPageId.toLowerCase() === this.keyName
    )[0];
    let data = this.pageData?.fields;
    this.setData(data);
    this.posthogService.capturePageViewEvent(this.keyName);
  }
  async setData(data: any) {
    if (data != null) {
      this.getStartedData = {
        header: data?.gettingStartedPanel?.fields?.title || '',
        button1: {
          url:
            data?.gettingStartedPanel?.fields?.buttons[0]?.fields
              ?.redirectLink || '',
          text:
            data?.gettingStartedPanel?.fields?.buttons[0]?.fields?.buttonText ||
            '',
          target:
            data?.gettingStartedPanel?.fields?.buttons[0]?.fields?.actionType ||
            '',
        },
        button2: {
          url:
            data?.gettingStartedPanel?.fields?.buttons[1]?.fields
              ?.redirectLink || '',
          text:
            data?.gettingStartedPanel?.fields?.buttons[1]?.fields?.buttonText ||
            '',
          target:
            data?.gettingStartedPanel?.fields?.buttons[1]?.fields?.actionType ||
            '',
        },
      };
      if (isPlatformServer(this.platformId)) {
        this.transferState.set(this.keyName, this.getStartedData);
      }
      this.cdr.detectChanges();
    }
  }
}
